import { render } from "./alarmList.vue?vue&type=template&id=428a58cd&scoped=true"
import script from "./alarmList.vue?vue&type=script&lang=js"
export * from "./alarmList.vue?vue&type=script&lang=js"

import "./alarmList.vue?vue&type=style&index=0&id=428a58cd&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428a58cd"]])

export default __exports__